import dayjs from 'dayjs'
import type { Action } from 'redux'
import type { InvokeDefinition } from '../../../signalr/types'
import { payloadAsParam } from '../../../signalr/helpers'
import { addToast } from '../../toasts/actions'
import { saveBBMISINsFailure } from './actions'
import type { BBMISIN } from './types'

export const saveBBMISINDefinition: InvokeDefinition<
  [BBMISIN[]],
  string,
  Action
> = {
  method: 'SaveBBMISINData',
  getParams: payloadAsParam,
  mapResponse: () =>
    addToast({
      message: 'Success',
      options: {
        toastId: `bbmisin-${dayjs().toString()}`,
        type: 'success'
      }
    }),
  mapError: saveBBMISINsFailure
}
